import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FeiraClienteDto } from '../dto/feira-cliente.dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FeiraClienteService {
  private _apiUrl = environment.apiUrl + "/v1/FeiraCliente";

  constructor(private http: HttpClient) { }

  getFeirasCliente(clienteid: string): Observable<FeiraClienteDto[]> {
    return this.http.get<FeiraClienteDto[]>(`${this._apiUrl}/${clienteid}`)
  }

  atualizarFeiraCliente(feiraCliente: FeiraClienteDto): Observable<FeiraClienteDto> {

    let id = feiraCliente.id;

    return this.http.put<FeiraClienteDto>(`${this._apiUrl}/${id}`, feiraCliente);
  }
}
